import axiosInstance from "services/AxiosInstance";

export const deleteUserService = async (id: string) => {
  const response = await axiosInstance.delete(`/users/${id}`);
  return response.data;
};
